export default __webpack_public_path__ + "static/media/buttonDanceActive.b0c48bd3.svg";